

import React, { SyntheticEvent } from "react"
import { GetAuth, HttpsRequest } from "../component/Utils"
import MenuComp, { PageTitle } from "../component/menucomp";
import { URLENUM } from "../component/Texts";
import Pagination from "../component/Paginator"
import { FaEdit, FaPlusSquare } from "react-icons/fa";
import { FormGroup } from '../component/form';
import { Loading, ActionBar, BoxArea } from "../component/BaseComponent";


type TeamUIProp = {
}

type TeamDataProp = {
    name: string;
    phone: string;
    email: string;
    last_seen: string;
    active: boolean;
    id: number;
}

type TeamUIState = {
    body: TeamDataProp[];
    isbusy: boolean;
    pager: PagerType,
    split: boolean;
    form: Record<string, number | string | unknown>[];
    data: Record<string, number | string | unknown>;
    is_edit: boolean;
}

class TeamUI extends React.Component<TeamUIProp, TeamUIState> {

    constructor(props: TeamUIProp) {
        super(props);
        this.state = {
            body: [],
            isbusy: true,
            pager: {
                next_page: 0,
                page: 1,
                pages: [],
                prev_page: 0,
                total: 0,
                rows: 10
            },
            split: false,
            form: [],
            data: {},
            is_edit: false,
        }

    }

    fetch_callback = (resp: callbackType) => {

        if (resp.status === -1) {
            alert(resp.errormsg)
            this.setState({ isbusy: false })
            return false
        }

        const { data, pager } = resp.body;

        this.setState({
            body: data,
            isbusy: false,
            pager: {
                page: pager['page'],
                pages: pager['pages'],
                prev_page: pager['prev_page'],
                total: pager['total'],
                next_page: pager['next_page'],
                rows: this.state.pager.rows
            },
        });

    }

    componentDidMount(): void {
        HttpsRequest.get(URLENUM.team_member, this.fetch_callback, GetAuth())
    }

    refresh_page = (page: number, rows?: string) => {

        HttpsRequest.get(
            URLENUM.team_member,
            this.fetch_callback,
            GetAuth(), { 'page': String(page), "rows": rows || '10' }
        )

        const { pager } = this.state
        pager.rows = rows ? Number(rows) : 10
        this.setState({ isbusy: true, pager: pager });

    }

    load_user_form = (resp: callbackType) => {

        if (resp.status !== 0) {
            this.setState({ isbusy: false })
            alert(resp.status_msg)
        }
        if (this.state.is_edit) {
            this.setState({
                form: resp.body.form,
                data: resp.body.rawdata,
                isbusy: false,
                split: true
            })
        } else {
            this.setState({
                form: resp.body.form,
                isbusy: false,
                split: true
            })
        }

    }
    get_user_form = (id?: number) => {

        let edit_state = false;

        if (id) {
            HttpsRequest.get(URLENUM.team_member_edit + `${id}`, this.load_user_form, GetAuth());
            edit_state = true;
        } else {
            HttpsRequest.get(URLENUM.team_member_add, this.load_user_form, GetAuth());
        }

        this.setState({
            isbusy: true,
            is_edit: edit_state
        })

    }

    create_update_user = (event: SyntheticEvent<HTMLFormElement>) => {

        event.preventDefault();
        const content = this.state.data

        if (this.state.is_edit) {
            HttpsRequest.post(URLENUM.team_member_edit + content.id, content, this.post_put_callback, GetAuth())
        } else {
            content.id = null; // to ensure the id is always null  
            HttpsRequest.post(URLENUM.team_member_add, content, this.post_put_callback, GetAuth())
        }

        this.setState({
            isbusy: true
        })

    }

    post_put_callback = (resp: callbackType) => {

        if (resp.status === -1) {
            this.setState({
                form: resp.body.form as Record<string, any>[],
                isbusy: false
            })
            return
        }

        if (this.state.is_edit) {
            // handle edit response 
        }

        this.setState({
            split: false,
        }, () => this.refresh_page(1))

    }

    onchange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {

        const name: string = target.name;
        const value: string = target.value;
        const checked: boolean = target.checked;
        const type: string = target.type;

        if (type === 'checkbox') {
            this.setState({ data: Object.assign({}, this.state.data, { [name]: checked }) });
            return;
        }

        this.setState({ data: Object.assign({}, this.state.data, { [name]: value }) });
    }

    render() {

        return (
            <div>
                <MenuComp />
                <br /><br />
                <ActionBar
                    search
                    classname={this.state.split ? "col-md-6" : "col-md-8"}
                    placeholder="search by email"
                    btnfunc={(e) => { e.preventDefault(); this.get_user_form(undefined) }}
                    btnicon={<FaPlusSquare size={20} />}
                />
                <br />
                <div className="container-fluid">
                    <div className="row posrel">
                        <BoxArea classname={this.state.split ? "col-md-6" : "col-md-8"}>

                            <PageTitle title={'Team Members'} />

                            <div className="table-responsive posrel">

                                <table className="table table-condensed table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <td> Name </td>
                                            <td> Phone </td>
                                            <td> Email </td>
                                            <td> Status </td>
                                            <td> Last Seen </td>
                                            <td> Action </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.body.length === 0 ? <tr> <td colSpan={7}> <i> no data found...</i></td> </tr> : (
                                                this.state.body.map((item, idx) => (
                                                    <tr>
                                                        <td>{item.name}</td>
                                                        <td>{item.phone} </td>
                                                        <td>{item.email} </td>
                                                        <td> {
                                                            item.active ? (
                                                                <span className="text-white badge bg-success"> Active </span>
                                                            ) : (
                                                                <span className="text-white badge bg-danger"> In-Active </span>
                                                            )
                                                        }
                                                        </td>
                                                        <td> {item.last_seen}</td>
                                                        <td>
                                                            <button className="btn btn-light btn-sm" onClick={() => this.get_user_form(item.id)}> <FaEdit /> Edit </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )
                                        }
                                    </tbody>
                                </table>
                                {this.state.isbusy && <Loading />}
                            </div>
                            <Pagination {...this.state.pager} navigate={this.refresh_page} />

                        </BoxArea>
                        {
                            this.state.split ? (
                                <BoxArea classname="col-md-6">

                                    <PageTitle title={'New Team Members'} />
                                    <div className='posrel'>
                                        <form method='post'
                                            autoComplete="off"
                                            onSubmit={this.create_update_user}>

                                            {
                                                this.state.form.map((fld, idx) => {
                                                    return <FormGroup
                                                        key={`tm-${idx}`}
                                                        obj={fld} onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                            this.onchange(e);
                                                        }}
                                                    />;
                                                })
                                            }

                                            <div className="mb-4 mt-4 padv5">
                                                <div className="form-group row">
                                                    <div className="d-flex justify-content-around">
                                                        <div className="d-grid gap-2 col-3">
                                                            <button type="submit" className="btn btn-primary btn-lg">
                                                                Save
                                                            </button>
                                                        </div>
                                                        <div className="d-grid gap-2 col-3">
                                                            <button type="button" onClick={() => this.setState({ split: false })} className="btn btn-light btn-lg">
                                                                &nbsp;&nbsp; Cancel &nbsp;&nbsp;
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                         {this.state.isbusy && <Loading />}
                                    </div>

                                </BoxArea>
                            ) : null
                        }
                        
                    </div>
                </div >

            </div >
        )
    }



}


export default TeamUI

